export default "__VITE_ASSET__DzPxY6kY__"